const downloadFile = (data: any, title: string, isCsv?: boolean) => {
	const url = window.URL.createObjectURL(new Blob([isCsv ? `\uFEFF${data}` : data]));
	const link = document.createElement("a");
	link.href = url;
	link.setAttribute("download", title);
	document.body.appendChild(link);
	link.click();
	link.remove();
};

export default downloadFile;
